import { cn } from '@bem-react/classname';

export const cnTheme = cn('Theme');
